const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const entryIdsWithStatus = (entryIds, status = 'delete') =>
  Object.values(entryIds)
    .map((entryId) => Object.values(entryId))
    .flat()
    .map((entryId) => entryId.migratortronTarget)
    .map((entryId) => Object.values(entryId))
    .flat()
    .filter((entryId) => entryId.status === status);

describe('Migrate entries', () => {
  describe('preview migrating a single entry with "transformGuids: false"', () => {
    const mock = loadRecordedMock(
      'migrate_entries_single_notransform_preview.json'
    );

    it(`should return one entry and the guids should match`, (done) => {
      migratortronApi.post(
        'migrate/entries?single&notransform',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          const migrateEntry = Object.entries(
            body?.entriesToMigrate?.entryIds?.simpleContent
          )[0];
          const targetGuid = Object.entries(migrateEntry[1].migratortron)[0][0];
          expect(targetGuid).to.equal(migrateEntry[0]);
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry with approval workflow', () => {
    const mock = loadRecordedMock(
      'migrate_entries_single_approval_preview.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries?single&approval',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });

  describe('migrate a single entry with approval workflow', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_single_approval.json'
    );

    it(`should create one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&approval',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single entry with approval workflow', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_single_approval_repeat.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&approval&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock('migrate_entries_single_simple_preview.json');

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries?single&simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });

  describe('migrate a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock('migrate_entries_commit_single_simple.json');

    it(`should create one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_single_simple_repeat.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock('migrate_entries_single_linked_preview.json');

    it(`should return 24 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries?single&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(24);
          done();
        }
      );
    });
  });

  describe('migrate a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock('migrate_entries_commit_single_linked.json');

    it(`should create 20 entries and update one with a second pass`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(24);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(23);

          expect(body?.migrateResult.created).to.equal(23);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_single_linked_repeat.json'
    );

    it(`should return 24 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?single&linked&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(24);
          expect(jpath('existing.*.totalCount', body)).to.equal(24);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry by contentTypeId and guid with linked nodes containing entries', () => {
    const mock = loadRecordedMock('migrate_entries_nodes_linked_preview.json');

    it(`should return 26 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries?nodes&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body?.entries?.migratortron?.totalCount).to.equal(26);
          expect(body?.nodes?.migratortron?.totalCount).to.equal(2);
          done();
        }
      );
    });
  });

  describe('migrate a single entry by contentTypeId and guid with linked nodes containing entries', () => {
    const mock = loadRecordedMock('migrate_entries_commit_nodes_linked.json');

    it(`should create 23 entries and update one with a second pass`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?nodes&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(26);
          expect(jpath('existing.*.totalCount', body)).to.equal(25);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(1);
          expect(jpath('nodesToMigrate.*.totalCount', body)).to.equal(4);

          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          expect(body?.nodesResult.created).to.equal(4);
          expect(body?.nodesResult.updated).to.equal(0);
          expect(body?.nodesResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single entry by contentTypeId and guid with linked nodes containing entries', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_nodes_linked_repeat.json'
    );

    it(`should return 26 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?nodes&linked&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(jpath('entries.*.totalCount', body)).to.equal(26);
          expect(jpath('existing.*.totalCount', body)).to.equal(26);
          // TODO: check why this makes an update
          // expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          // expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry containing tags and resource pickers', () => {
    const mock = loadRecordedMock('migrate_entries_pickers_preview.json');
    const expectedTags = mock.response.tags.migratortron.totalCount;

    it(`should return one entry and ${expectedTags} tags`, (done) => {
      migratortronApi.post(
        'migrate/entries?pickers',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing?.migratortronTarget?.totalCount).to.equal(0);
          expect(body.entries?.migratortron?.totalCount).to.equal(1);
          expect(body.entriesToMigrate?.migratortronTarget.totalCount).to.equal(1);
          expect(
            body.entriesToMigrate.migratortronTarget.resourcePickers.create
          ).to.equal(1);
          expect(
            entryIdsWithStatus(body.entriesToMigrate.entryIds, 'create')
          ).to.have.a.lengthOf(1);

          expect(body.tags?.migratortron?.totalCount).to.equal(expectedTags);

          expect(body.tagsToMigrate?.migratortronTarget.create).to.equal(
            expectedTags
          );
          done();
        }
      );
    });
  });

  describe('migrate a single entry containing tags and resource pickers', () => {
    const mock = loadRecordedMock('migrate_entries_commit_pickers.json');

    const expectedTags = mock.response.tags.migratortron.totalCount;

    it(`should create one entry and ${expectedTags} tags`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?pickers',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing?.migratortronTarget?.totalCount).to.equal(0);
          expect(body.entries?.migratortron?.totalCount).to.equal(1);
          expect(body.entriesToMigrate?.migratortronTarget.totalCount).to.equal(1);
          expect(
            body.entriesToMigrate.migratortronTarget.resourcePickers.create
          ).to.equal(1);
          expect(
            entryIdsWithStatus(body.entriesToMigrate.entryIds, 'create')
          ).to.have.a.lengthOf(1);

          expect(body.tags?.migratortron?.totalCount).to.equal(expectedTags);

          expect(body.tagsToMigrate?.migratortronTarget.create).to.equal(
            expectedTags
          );

          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          expect(body?.tagsResult.created).to.equal(expectedTags);
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single entry containing tags and resource pickers', () => {
    const mock = loadRecordedMock('migrate_entries_commit_pickers_repeat.json');
    const expectedTags = mock.response.tags.migratortron.totalCount;

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?pickers&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.be.undefined;

          expect(body.committed).to.be.true;

          expect(body.existing?.migratortronTarget?.totalCount).to.equal(1);
          expect(body.entries?.migratortron?.totalCount).to.equal(1);
          expect(body.entriesToMigrate?.migratortronTarget.totalCount).to.equal(0);
          expect(
            body.entriesToMigrate.migratortronTarget.resourcePickers['no change']
          ).to.equal(1);
          expect(
            entryIdsWithStatus(body.entriesToMigrate.entryIds, 'no change')
          ).to.have.a.lengthOf(1);

          expect(body.tags?.migratortron?.totalCount).to.equal(expectedTags);

          expect(body.tagsToMigrate?.migratortronTarget['no change']).to.equal(
            expectedTags
          );

          expect(body.migrateResult?.created).to.equal(0);
          expect(body.migrateResult.updated).to.equal(0);
          expect(body.migrateResult.errors).to.not.exist;
          expect(body.tagsResult?.created).to.equal(0);
          done();
        }
      );
    });
  });

  describe('preview migrating a single entry containing an invalid resource picker', () => {
    const mock = loadRecordedMock(
      'migrate_entries_pickers_invalid_preview.json'
    );

    it(`should return one entry with error status`, (done) => {
      migratortronApi.post(
        'migrate/entries?pickers&invalid',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.committed).to.be.false;
          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(1);
          expect(body.entries?.migratortron?.totalCount).to.equal(1);
          expect(
            Object.values(
              Object.values(
                body.entriesToMigrate?.entryIds.resourcePickers
              )?.[0]?.migratortronTarget
            )?.[0].error
          ).to.contain('could not validate resource picker');

          done();
        }
      );
    });
  });
});
